import { useUser } from "@context/User/UserContext";
import { Avatar, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ProfileDrawer from "./ProfileDrawer";

export interface UserAvatarProps {
  color?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ color: _color }) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <IconButton
        onClick={() => setDrawerOpen(true)}
        size="small"
        sx={{
          p: 0.5,
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)"
          }
        }}
        aria-label={t("navbar.user_menu")}
      >
        <Avatar
          src={user.avatarUrl}
          alt={user.name}
          sx={{
            width: 32,
            height: 32
          }}
        />
      </IconButton>

      <ProfileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default UserAvatar;
